import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import ShowAlert from "@/hooks/show-alert"
import { CheckIcon, CloseIcon, DeleteIcon } from "../ui/Icons/TooltipIcon"
import DeleteButton from "../ui/delete-button"
import FrmGroupEditTasks from "./frmGroupEditTasks"

const GroupEditTasksBuilder = () => {
  const props = useContext(PlanBuilderContext);

function haveDependents() {
    for (let i = 0; i < props.selectedTaskIDs.length; i++) {
        const dependents = props.getDependents(props.selectedTaskIDs[i]);
        if (dependents.length > 0) {
            return true;
        }
    }
    return false;
}

  return (
    <div className="flex flex-col border-2 border-gray-500 rounded-md ml-2 min-w-[450px] h-min">
        <div className={"flex flex-row justify-between items-center bg-planbuilder-task text-planbuilder-task-header-foreground px-2"}>
            <div>
                {props.selectedTaskIDs.length} Tasks Selected
            </div>
              <div className='flex flex-row'>
                  <button onClick={() => props.completeMultipleTasks(props.selectedTaskIDs)} disabled={props.projectLifecycleStage !== "Execution"}><CheckIcon tooltip="Mark as Completed" /></button>
                {haveDependents() ? 
                <ShowAlert
                title={"Delete Task?"}
                message={"Selected tasks have dependents and cannot be deleted."}
                >
                  <DeleteIcon
                  tooltip={"Selected tasks have dependents and cannot be deleted."}
                  />
                </ShowAlert>
                : 
                <DeleteButton
                  action={() => props.groupDeleteTasks(props.selectedTaskIDs)}
                  title={"Delete Tasks?"}
                  message={"Are you sure you want to delete the selected tasks?"}
                  tooltip={"Delete tasks"}
                />
                }
                <div className='my-auto' onClick={() => props.setShowEditForm(false)} ><CloseIcon className="text-white rounded-md cursor-pointer hover:bg-red-500" /></div>
              </div>
            </div>
            <div className="flex flex-row p-4 w-full">
              <div className="flex flex-col w-full">
                <FrmGroupEditTasks ids={props.selectedTaskIDs} groupEditTasks={props.groupEditTasks} highlightedTask={props.selectedTaskID as number}/>
              </div>
            </div>
    </div>
  )
}

export default GroupEditTasksBuilder